import moment from 'moment';
import {joinedValuesSeparator, dateFormat} from '@/ts/DefaultTableConfigs';

export default class Transaction {

    public id: string;
    public date: string;
    public orderDate: string;
    public orderType: string;
    public orderId: string;
    public orderAmount: number;
    public additionalData: [];
    public orderDescription: string;
    public paymentMethod: string;
    public paymentStatus: string;
    public currency: string;
    public unitId: number;
    public unitTitle: string;
    public unitAddress: string;
    public tenantName: string;
    public tenantId: number;
    public project: string;
    public paymentDate: string;
    public totalAmount: number;
    public vatAmount: number;
    public transactionId: string;


    // payment status (Authorised, Confirmed, declined, Chargeback etc)
    constructor(
         externalId: string,
         date: string,
         orderDate: string,
         orderType: [],
         orderId: string,
         orderAmount: number,
         unitId: number,
         unitTitle: string,
         unitAddress: string = null,
         additionalData: [] = null,
         orderDescription: string = null,
         paymentMethod: string = null,
         paymentStatus: string = null,
         currency: string = null,
         tenantName: string = null,
         tenantId: number = null,
         project: string = null,
         paymentDate: string = null,
         totalAmount: number = null,
         vatAmount: number = null,
         transactionId: string = null,
    ) {
        this.id =  externalId;
        this.date =  moment(date).local().format(dateFormat);
        this.orderDate =  moment(orderDate).local().format(dateFormat);
        this.orderType = orderType.join(joinedValuesSeparator);
        this.orderId = orderId;
        this.orderAmount = orderAmount;
        this.unitId = unitId;
        this.unitTitle = unitTitle;
        this.unitAddress = unitAddress;
        this.additionalData = additionalData;
        this.orderDescription = orderDescription;
        this.paymentMethod = paymentMethod;
        this.paymentStatus = paymentStatus;
        this.currency = currency;
        this.tenantName = tenantName;
        this.tenantId = tenantId;
        this.project = project;
        this.paymentDate = paymentDate;
        this.totalAmount = totalAmount;
        this.vatAmount = vatAmount;
        this.transactionId = transactionId;
    }

    get momentDate() {
        return moment(this.orderDate, dateFormat);
    }

    public compareDateAndReturnIfNotExists(date: any) {
        return typeof date === 'undefined' ? true : this.momentDate.isSameOrAfter(date.date);
    }
}
